import {API} from "../../../api/api";
import {PresetsAPIRoutes} from "./apiRoutes";

const getSubsidiaries = () => {
    const odataParameters = {
        skip: 0,
        top: 10000
    };
    return API.request({
        routeID: PresetsAPIRoutes.GET_SUBSIDIARIES,
        odataParameters
    });
};

const getPresets = ({page, top, search, subsidiaries, types, prizeType, status, certified}) => {
    let odataParameters = {
        skip: page * top,
        top,
        orderby: "id"
    };

    if (search) {
        odataParameters["search"] = search;
    }

    if (status) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}active eq ${status}`;
    }

    if (certified) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}certified eq ${certified}`;
    }

    if (subsidiaries && subsidiaries.length > 0) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}subsidiary_id in (${subsidiaries
            .map(c => c)
            .join(",")},)`;
    }

    if (types && types.length > 0) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}progressive_type_id eq ${types}`;
    } else {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";
        odataParameters["filter"] = `${prepend}progressive_type_id in (0,1,2,3,4,7,8,9,)`
    }

    if (prizeType != undefined && prizeType.length > 0) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}stype eq '${prizeType}'`;
    }

    return API.request({
        routeID: PresetsAPIRoutes.GET_PRESETS,
        odataParameters
    });
};

const addPreset = json => {
    return API.request({
        routeID: PresetsAPIRoutes.NEW_PRESET,
        parameters: {...json},
        formData: false
    });
};

const getPreset = presetId => {
    return API.request({
        routeID: PresetsAPIRoutes.GET_PRESET,
        routeParameters: {
            preset_id: presetId
        }
    });
};

const editPreset = (presetId, json) => {
    return API.request({
        routeID: PresetsAPIRoutes.EDIT_PRESET,
        parameters: {...json},
        routeParameters: {preset_id: presetId},
        formData: false
    });
};

const activatePreset = presetId => {
    return API.request({
        routeID: PresetsAPIRoutes.EDIT_PRESET,
        parameters: {active: true},
        routeParameters: {preset_id: presetId},
        formData: false
    });
};

const deactivatePreset = presetId => {
    return API.request({
        routeID: PresetsAPIRoutes.EDIT_PRESET,
        parameters: {active: false},
        routeParameters: {preset_id: presetId},
        formData: false
    });
};

const certifiedPreset = (presetId, certified) => {
    return API.request({
        routeID: PresetsAPIRoutes.CERTIFIED_PRESET,
        parameters: {certified: certified},
        routeParameters: {preset_id: presetId},
        formData: false
    });
};

const getDenominations = () => {
    return API.request({
        routeID: PresetsAPIRoutes.GET_DENOMINATIONS,
        odataParameters: {
            skip: 0,
            top: 10000
        }
    });
};

const getGameBundles = () => {
    return API.request({
        routeID: PresetsAPIRoutes.GET_BUNDLES,
        odataParameters: {
            orderby: "name"
        }
    });
};

const getGames = () => {
    return API.request({
        routeID: PresetsAPIRoutes.GET_GAMES,
        odataParameters: {
            orderby: "id"
        }
    });
};

export const presetsAPI = {
    getSubsidiaries,
    getPresets,
    addPreset,
    getPreset,
    editPreset,
    getDenominations,
    activatePreset,
    deactivatePreset,
    certifiedPreset,
    getGameBundles,
    getGames
};
